import { useCallback, useState } from "react";

const usePostNotificationsAlerts = (alertType) => {
    const [postError, setPostError] = useState(null);
    const [alertResponse, setAlertResponse] = useState(null);

    const postNotificationsAlerts = useCallback(async (requestPayload) => {
        const POST_EDI_TRANSACTIONS_ALERTS = process.env.REACT_APP_POST_EDI_TRANSACTIONS_ALERTS;
        const APIKEY = process.env.REACT_APP_APIKEY;

        if (!POST_EDI_TRANSACTIONS_ALERTS || !APIKEY) {
            setPostError(new Error("Required environment variables are missing"));
            return;
        }

        try {
            console.log("URL: ", POST_EDI_TRANSACTIONS_ALERTS);

            const response = await fetch(POST_EDI_TRANSACTIONS_ALERTS, {
                method: "POST",
                headers: {
                    "x-api-key": APIKEY,
                    "Content-Type": "application/json",
                    "notificationType": alertType
                },
                body: JSON.stringify(requestPayload)
            });

            if (response.ok) {
                const data = await response.json();
                setAlertResponse(data);
            } else {
                const errorData = await response.text(); // or response.json() based on the API
                throw new Error(`Network response was not ok: ${response.statusText} - ${errorData}`);
            }
        } catch (error) {
            console.error('Error posting notification alert:', error);
            setPostError(error);
        }
    }, [alertType]);

    return { postNotificationsAlerts, alertResponse, postError };
};

export default usePostNotificationsAlerts;
